import { render, staticRenderFns } from "./characterModal.vue?vue&type=template&id=354c62f2&scoped=true&"
import script from "./characterModal.vue?vue&type=script&lang=js&"
export * from "./characterModal.vue?vue&type=script&lang=js&"
import style0 from "./characterModal.vue?vue&type=style&index=0&id=354c62f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c62f2",
  null
  
)

export default component.exports